import { DialogComponent } from '@theme/dialog';

/**
 * Dialog for selecting an engine family (metaobject).
 * On selection, stores system.id and system.handle in cart attributes,
 * closes the dialog, and reloads so Liquid can read cart.attributes.
 *
 * @extends {DialogComponent}
 */
class EngineFamilyDialogComponent extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();
  }

  /**
   * Handles engine family selection: persist id and handle in cart attributes, close, reload.
   * Expects elements with data-engine-family-id and data-engine-family-handle.
   *
   * @param {Event} event - Click event.
   */
  async onEngineFamilySelect(event) {
    const target = event.target instanceof Element ? event.target.closest('[data-engine-family-id]') : null;
    if (!target) return;

    const id = target.getAttribute('data-engine-family-id');
    const handle = target.getAttribute('data-engine-family-handle');

    if (!id || !handle) return;

    await this.#updateCartAttributes({
      engine_family_id: id,
      engine_family_handle: handle,
    });

    await this.closeDialog();

    window.location.reload();
  }

  /**
   * Handles engine family deselection: removes cart attributes, closes, reloads.
   *
   * @param {Event} event - Click event.
   */
  async onEngineFamilyDeselect(event) {
    event.preventDefault();

    await this.#updateCartAttributes({
      engine_family_id: '',
      engine_family_handle: '',
    });

    await this.closeDialog();

    // Remove filter parameter from URL and reload
    const url = new URL(window.location.href);
    url.searchParams.delete('filter.p.m.custom.engine_family');
    window.location.href = url.toString();
  }

  /**
   * Updates cart attributes using the Shopify AJAX cart API.
   *
   * @param {Record<string, string>} attributes
   */
  async #updateCartAttributes(attributes) {
    try {
      const response = await fetch(Theme.routes.cart_update_url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({ attributes }),
      });

      if (!response.ok) {
        console.error('Failed to update cart attributes for engine family selection.');
      }
    } catch (error) {
      console.error('Error updating cart attributes for engine family selection.', error);
    }
  }
}

if (!customElements.get('engine-family-dialog-component')) {
  customElements.define('engine-family-dialog-component', EngineFamilyDialogComponent);
}